import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import GallectionCover from '../GallectionCover';
const GallectionListItemButton = (_param)=>{
    var { gallection } = _param, rest = _object_without_properties(_param, [
        "gallection"
    ]);
    return /*#__PURE__*/ React.createElement(ListItemButton, _object_spread({
        label: gallection.name,
        prefix: /*#__PURE__*/ React.createElement(GallectionCover, {
            gallection: gallection
        }),
        fillContainerWidth: true
    }, rest));
};
GallectionListItemButton.displayName = 'GallectionListItemButton';
export default GallectionListItemButton;

//# sourceMappingURL=GallectionListItemButton.js.map